<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
            <span class="field-title">{{$t('labels.uploadHelpText')}}</span><br><br>
            <a href="https://ghosteo.it/example.xlsx">
            <v-btn
                color="white"
                style="background:rgb(33, 33, 33);font-size:20px;float:right;margin-left:0"
                flat
            >
                <v-icon>download</v-icon>&nbsp;&nbsp;{{$t('labels.downloadExampleFile')}}
            </v-btn></a>
            <br>
        </v-layout>
        <v-layout row wrap>
            <span class="field-title">{{$t('labels.uploadHelpTextPart2')}}</span>
        </v-layout>
        <v-layout row wrap> 
            <input type="file" id="xlsx" name="xlsx" @change="onChange" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
        </v-layout>
        <div class="bottom-bar-holder">
            <div class="bottom-bar">
                <v-layout
                    justify-center
                    style="padding:0"
                >
                    <v-btn
                        color="white"
                        style="background:#4caf50;font-size:20px;float:right;"
                        @click.native="uploadFile()"
                        flat
                    >
                        <v-icon>upload</v-icon>&nbsp;&nbsp;{{$t('labels.upload')}}
                    </v-btn>
                </v-layout>
            </div>
        </div>
        <v-dialog
            v-model="showFinalizeImportDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.finalizeImport')}}
                </v-card-title>
                <v-card-text>
                    {{$t('labels.finalizeImportNewSpeciesPart1')}}{{ newSpecies.length }} {{$t('labels.finalizeImportNewSpeciesPart2')}}:<br>
                    <ul>
                        <li v-for="s in newSpecies" style="font-style: italic;">{{s.full}}</li>
                    </ul> 
                    <br>
                    {{ importRows.length }} {{$t('labels.finalizeImportResearches')}}.
                    <br>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="#333"
                    style="color:white"
                    text
                    @click="showFinalizeImportDialog = false"
                >
                    {{$t('labels.cancelImport')}}
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="showFinalizeImportDialog = false;completeImport();"
                >
                    OK
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="showCreatingDialog"
            width="500"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.importingTitle')}}
                </v-card-title>
                <v-card-text>
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                    &nbsp;{{$t('labels.importingText')}}
                    <br>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="importSuccess" top>
            {{$t('labels.importSuccess')}}
        </v-snackbar>
    </v-container>    
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Import',
    data: function(){
        return{
            showFinalizeImportDialog: false,
            showCreatingDialog: false,
            importSuccess:false,
            newSpecies: [],
            existingSpecies: [],
            importRows: []
        };
    },
    mounted: function(){
    },
    methods:{
        onChange(e) {
            let vm = this;
            vm.file = e.target.files[0];
        },
        async completeImport(){
            let vm = this;
            vm.showCreatingDialog = true;
            //creating the species
            for (const s of vm.newSpecies){
                await axios({
                    method: "POST",
                    url: vm.$API_BASE_URL + "species/create.php",
                    data: {
                        "order": s.order,
                        "suborder": s.suborder,
                        "family": s.family,
                        "genus": s.genus,
                        "species": s.species
                    },
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("herp_at")
                    }
                })
                .then(function (response) {
                    if (response.status != 200) {
                        alert(vm.$t('labels.errorLoading'));
                    }
                })
                .catch(function (error) {
                    if(error.response.status==403||error.response.status==401){
                        vm.$router.push({name: 'login'});
                    }
                    else{
                        alert(vm.$t('labels.errorLoading'));
                        console.error(error)
                    }
                    vm.showCreatingDialog = false;
                });
            };
            //importing the researches
            for (const r of vm.importRows){
                axios({
                    method: "POST",
                    url: vm.$API_BASE_URL + "researches/create.php",
                    data: {
                        "reference": r.AH,
                        "abc": r.AJ,
                        "notes": r.AK,
                        "inAfrica": r.D == 1,
                        "inAmerica": r.E == 1, 
                        "inAsia": r.F == 1, 
                        "inEurope": r.H == 1, 
                        "inAustralia": r.G == 1, 
                        "cranium": r.I == 1, 
                        "lowerJaw": r.J == 1, 
                        "teeth": r.K == 1, 
                        "hyoid": r.L == 1, 
                        "vertebrae": r.M == 1, 
                        "ribs": r.N == 1, 
                        "girdles": r.O == 1, 
                        "limbs": r.P == 1, 
                        "osteoderms": r.Q == 1, 
                        "shell": r.R == 1, 
                        "intraspecificVariation": r.S == 1,
                        "ontogeneticVariation": r.U == 1,
                        "sexDim": r.T == 1, 
                        "hasDescription": r.V == 1, 
                        "hasFigure": r.W == 1, 
                        "hasScoring": r.X == 1, 
                        "hasGeometricMorphology": r.Y == 1, 
                        "hasFiniteElementsAnalysis": r.Z == 1, 
                        "drySkeleton": r.AA == 1, 
                        "clearingAndStaining": r.AB == 1, 
                        "ctScan": r.AC == 1, 
                        "xRays": r.AD == 1, 
                        "histological": r.AE == 1, 
                        "specimenCount": r.AF, 
                        "newSpeciesDescribed": r.AG == 1,  
                        "year":r.AI, 
                        "entryBy":r.AL, 
                        "speciesId":null,
                        "full": r.A.trim(),
                    },
                    headers: {
                        'Authentication-Token': window.localStorage.getItem("herp_at")
                    }
                })
                .then(function (response) {
                    if (response.status != 200) {
                        alert(vm.$t('labels.errorLoading'));
                    }
                })
                .catch(function (error) {
                    if(error.response.status==403||error.response.status==401){
                        vm.$router.push({name: 'login'});
                    }
                    else{
                        alert(vm.$t('labels.errorLoading'));
                        console.error(error)
                    }
                });
            }
            //ending
            vm.showCreatingDialog = false;
            vm.importSuccess=true;
        },
        uploadSuccess(response){
            let vm = this;
            vm.showFinalizeImportDialog = true;
            vm.newSpecies = response.data.newSpecies;
            vm.existingSpecies = response.data.existingSpecies;
            vm.importRows = Object.values(response.data.rows);
        },
        uploadFile() {
            let vm = this;
            let formData = new FormData();
            formData.append("file", vm.file);
            axios.post(vm.$API_BASE_URL + "import.php", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                },
            }).then((response) => {
                vm.uploadSuccess(response);
            }).catch((error) => {
                if(error.response && error.response.data && error.response.data.message){
                    alert(error.response.data.message);
                }
                else{
                    alert(error);
                }
            });
        },
    }
}
</script>
